const { dataFormParse } = require('../utils/dataFormParse');
const { axiosDefault, handleErrors } = require('../utils/defaults');

const documentsService = {
  admin: {
    get: async (id) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/documents/gestao/${id ? id : ''}`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    getList: async () => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/documents/gestao`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    save: async (document) => {
      try {
        const axios = axiosDefault('file');

        const { data } = await axios.post(`/api/documents/gestao`, dataFormParse(document));
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    edit: async (document) => {
      try {
        const axios = axiosDefault('file');

        const { data } = await axios.put(
          `/api/documents/gestao/${document.id}`,
          dataFormParse(document),
        );

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    delete: async (id) => {
      try {
        const axios = axiosDefault();

        const { data } = await axios.delete(`/api/documents/gestao/${id}`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },

  user: {
    get: async (id) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/documents/${id}`);

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    getList: async ({ limit = '', search = '', offset = '', random = '' }) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(
          `/api/documents?limit=${limit}&title=${search}&offset=${offset}&random=${random}`,
        );

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },
};

export default documentsService;
